export default __webpack_public_path__ + "ef1451a094deabf295c72e50683a8a47.svg";